import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Icon } from "@iconify/react";
import BlogContactForm from '../../Components/Blogs/blog-contactform';


const BlogDetails = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    fetch(`https://blogs.eyantra.com/wp-json/wp/v2/posts?slug=${slug}&_embed=1`)
      .then(res => res.json())
      .then(data => {
        if (data.length > 0) {
          setPost(data[0]);
          document.title = data[0].yoast_head_json?.title || data[0].title.rendered;

          const metaTag = document.querySelector("meta[name='description']");
          if (metaTag) {
            metaTag.setAttribute("content", data[0].yoast_head_json?.description || '');
          }

        } else {
          console.error('Post not found');
        }
      })
      .catch(err => console.error('Error fetching post:', err));
  }, [slug]);

  if (!post) return <p>Loading...</p>;

  const imageUrl = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '/assests/blogBg.png';
  const authorName = post._embedded?.author?.[0]?.name;
  const publishDate = new Date(post.date).toLocaleDateString();

  return (
    <>
      <div className='container-fluid mt-4' id='bgBlog' style={{ backgroundImage: "url(/assests/blogBg.png)", backgroundSize: 'cover' }}>
        <Container className="h-100">
          <div className='d-flex justify-content-center align-items-center flex-column h-100 text-center'>
            <h1 className='fs-48 fw-bold'>Blogs</h1>
            <p className='text-center'>
              Read the latest articles, blogs, case studies, and many more published by eYantra
            </p>
          </div>
        </Container>
      </div>

      <div className='container-fluid bg-light py-5' id="blogCss">
        <Container>
        <Row>
          <Col md={8} className="mx-auto px-0">
            {imageUrl && (
              <img src={imageUrl} alt="Featured" className="img-fluid mb-4 rounded w-100 border-eY" />
            )}
            <Row className='align-items-center justify-content-start d-flex px-2'>
            <Col md={1} className=' col-1 p-0 mx-1 text-center'>
                <Icon icon="ic:round-person" width="32" height="32" className='rounded-circle border boder-secondary'/>
            </Col>
            <Col md={5} className='col-6 p-0 mx-1'>
                <strong className='p-0 m-0'>{authorName}</strong>
                <br/>
                <small>Posted On {publishDate}</small>
            </Col>
            </Row>
            <h5 className='fs-32 fw-bold pt-4' dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
            
            
            
                <div className='pt-4' id="blogContent" dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
            
          </Col>
          <Col md={4}>
              <BlogContactForm/>
          </Col>
        </Row>
        </Container>
      </div>
    </>
  );
};

export default BlogDetails;
